import React, { Component, Fragment } from "react";
import Helmet from "react-helmet";

import { title, List } from "utils";

import { Header } from "components";
import { Button, Input, notification } from "antd";

import { selectService } from "services";
import { optionService } from "services/option.service";
import SelectsContext from "constants/selectsContext";

class AdminPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selects: {},
      tvMessage: "",
      tvMessageInput: "",
    };
  }
  componentDidMount() {
    this.fetchSelects();
    this.fetchTvMessage();
  }

  fetchSelects() {
    selectService.listForPage("admin").then((selects) => this.setState({ selects }));
  }

  fetchTvMessage() {
    optionService.get("tv_message").then((value) => {
      this.setState({ tvMessage: value || "", tvMessageInput: value || "" });
    }).catch(() => {
      notification.error({
        message: "Erreur lors du chargement du message",
        placement: "bottomRight",
      });
    });
  }

  saveTvMessage() {
    optionService.set("tv_message", this.state.tvMessageInput).then((value) => {
      this.setState({ tvMessage: value || "", tvMessageInput: value || "" });
      notification.success({
        message: "Message enregistré",
        placement: "bottomRight",
      });
    }).catch(() => {
      notification.error({
        message: "Erreur lors de l'enregistrement",
        placement: "bottomRight",
      });
    });
  }

  render() {
    const { tvMessage, tvMessageInput } = this.state;
    const hasChanges = tvMessageInput !== tvMessage;

    return (
      <Fragment>
        <Helmet>{title("Admin")}</Helmet>

        <div className="admin-page main-content">
          <Header title="Admin" />

          <div className="admin-tv-message">
            <h3>Message de la direction (TV v2)</h3>
            <Input.TextArea
              rows={3}
              value={tvMessageInput}
              onChange={(e) => this.setState({ tvMessageInput: e.target.value })}
              placeholder="Entrez le message de la direction..."
            />
            {hasChanges && (
              <div className="admin-tv-message-actions">
                <a onClick={() => this.setState({ tvMessageInput: tvMessage })}>
                  Annuler
                </a>
                <Button onClick={() => this.saveTvMessage()}>
                  Enregistrer les changements
                </Button>
              </div>
            )}
          </div>

          <SelectsContext.Provider value={this.state.selects}>
            <List type="suppliers" title="Fournisseurs" />
          </SelectsContext.Provider>
          <List type="means" title="Moyens" />
          <List type="risks" title="Risques" />
          {/* <List type="licenses" /> */}
          {/* <List type="jobs" /> */}
          {/* <List type="projectTypes" /> */}
        </div>
      </Fragment>
    );
  }
}

export default AdminPage;
